import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Box, Button } from "@mui/material";
import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'
import './Index.css'
import PageMenu from "../../../../../components/custom/app/pageMenu/pageMenu";
import PageContentWrapper from "../../../../../components/mui/app/pageContentWrapper/pageContentWrapper";
import PageTitle from "../../../../../components/mui/app/pageTitle/pageTitle";
import QuickView from '../../../../../components/mui/general/quickView/quickView'
import DataGridWrapper from '../../../../../components/mui/grids/dataGridWrapper/dataGridWrapper'
import { access_user } from "../../../../../helpers/rights";
import useUserData from "../../../../../hooks/user/useUserData";
import { withPermissionHOC } from "../../../../permission/components/permissionHOC/permissionHOC";
import { useHasPermission } from "../../../../permission/hooks/useHasPermission";
import { USERS } from "../../../locales/namespaces";
import QuickDetailsUser from '../../QuickDetails/QuickDetailsUser.js'
import { UserGridContainer } from "./UserGridContainer";


function Index() {
	const { t } = useTranslation(USERS);
	const [userQuickView, setUserQuickView] = useState({
		open: false,
		userId: null
	})
	const { role } = useParams()
	
	const editUser = useHasPermission([], { shouldView: true })
	useEffect(() => {
		document.title = t('Users List')
	}, [])
	
	const closeQuickViewUser = () => {
		setUserQuickView({
			open: false,
			userId: null
		})
	}
	const { language, dateFormat } = useUserData()
	
	return (
		<Box className={'users_index'} sx={{marginTop:'10px'}}> {/* Χρήση Custom Wrapper Class που χαρακτηρίζει τη φόρμα. */}
			{/*TODO::Προσθήκη code='κωδικός μενού' όταν φτιαχτεί δυναμικό μενού χρηστών*/}
			{/*<SidePanelLinks/>*/}
			<PageMenu> {/* Top μενού σελίδας. Χρησιμοποιεί Button Group με variant 'contained' και size small. Τα buttons που περιέχει κληρονομούν αυτομάτως το αντίστοιχο variant και size. Δε δηλώνουμε άλλο variant, size ή χρώμα στα buttons εκτός αν θέλουμε για κάποιο συγκεκριμένο να το ξεχωρίσουμε. (πχ button διαγραφής) */}
				<Button
					component={Link}
					to={'/user/create' + '/' + role}
					startIcon={<AddCircleOutlineIcon/>}
				>
					{t('Add')}
				</Button>
			</PageMenu>
			<PageContentWrapper>
				<PageTitle
					title={role === '0' ? t('Users') : t('Workers')}/> {/* Custom mui component για τον τίτλο σελίδων. Χρησιμοποιεί styles από συγκεκριμένα properties της παλέτας. Με το Property withDivider, μπορεί να εμφανίσει και divider κάτω από τον τίτλο, το οποίο επίσης παίρνει styles από την παλέτα. */}
				<DataGridWrapper sx={{ height: 700 }}>
						<UserGridContainer
							key={role}
							role={role}
							language={language}
							dateFormat={dateFormat}
						/>
				</DataGridWrapper>
			</PageContentWrapper>
			<QuickView
				autoClose={true}
				show={userQuickView.open}
				onBackgroundClick={closeQuickViewUser}
			>
				<QuickDetailsUser
					userId={userQuickView.userId}
					onClose={closeQuickViewUser}
				/>
			</QuickView>
		</Box>
	)
}


export default withPermissionHOC(Index, [access_user])
// export default Index